export default {
  api: {
    base_url: process.env.VUE_APP_BACKEND_BASE_URL || 'https://ad-hoc-backend-dev.autosense-cloud.com',
    token: process.env.VUE_APP_BACKEND_TOKEN,
  },
};
